export enum SHOPFRONT_PAYMENT_EVENTS {
    DATA = "DATA",
    PING = "PING",
    CANCEL = "CANCEL",
    CLOSING = "CLOSING",
}

export enum SHOPFRONT_PAYMENT_DATA_TYPES {
    SALE = "SALE",
    CALCULATOR = "CALCULATOR",
    SETTLEMENT = "SETTLEMENT",
}

export enum GATEWAY_PAYMENT_EVENTS {
    REQUEST_DATA = "REQUEST_DATA",
    FINISH = "FINISH",
    PONG = "PONG",
    ERROR = "ERROR",
    RECEIPT = "RECEIPT",
    NO_RETURN = "NO_RETURN",
    CONNECTED = "CONNECTED",
    ACKNOWLEDGE_CLOSE = "ACKNOWLEDGE_CLOSE",
}
